import { EMPTY_VERSE_SLOT, QUESTION_PLACE } from "../constants/question";
import type {
	QuestionAuthor,
	QuestionBibleVerse,
	QuestionDraft,
	QuestionFromPlaceData,
	QuestionPlace,
} from "../types/question.types";

export const QUESTION_DEFAULTS: QuestionDraft = {
	question_text: "",
	question_bible_verses: [EMPTY_VERSE_SLOT],
	question_from_author: {},
	question_from_author_mentor: {},
	question_to_author: {},
	question_status: "unanswered",
	question_tags: "",
	question_answer: {},
	question_from_place: "",
	question_is_favorite: false,
};

interface Input {
	draft: QuestionDraft;
	author: QuestionAuthor & { user_mentor?: QuestionAuthor };
	// The modal may be opened without a place; it has always posted it as is.
	place: QuestionPlace | undefined;
	course?: { info: QuestionFromPlaceData; authors: Array<{ _id?: string }> };
}

/** The body of POST /v1/questions — one builder for the ask-question modal and the landing. */
export const buildQuestionPayload = ({ draft, author, place, course }: Input) => {
	// Only what the server needs to find the verses again; their text is not sent.
	const verses = draft.question_bible_verses
		.filter((verse): verse is QuestionBibleVerse => verse !== EMPTY_VERSE_SLOT)
		.map(verse => ({
			versesParams: verse.versesParams,
			verseAddress: verse.verseAddress,
			versesData: (verse.versesData ?? []).map(({ verse_num }) => ({ verse_num })),
		}));

	//! Вставлять данные юзера и его ментора на бэке (и question_is_hidden: false)
	return {
		...draft,
		question_bible_verses: verses,
		question_from_author: {
			_id: author._id,
			user_name: author.user_name,
			user_second_name: author.user_second_name,
			user_email: author.user_email,
		},
		question_from_author_mentor: author.user_mentor,
		question_from_place: place,
		...(place === QUESTION_PLACE.COURSE &&
			course && {
				question_from_place_data: course.info,
				question_to_author: course.authors.length ? course.authors[0] : {},
			}),
		question_is_hidden: false,
	};
};
